module.exports = __webpack_public_path__ + "img/mcontact2.662ab8f5.png";